import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Articles from "@/pages/Articles";
import ArticleDetail from "@/pages/ArticleDetail";
import Reports from "@/pages/Reports";
import ReportDetail from "@/pages/ReportDetail";
import Solutions from "@/pages/Solutions";
import LeadGeneration from "@/pages/LeadGeneration";
import Partnerships from "@/pages/Partnerships";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";

function App() {
  useEffect(() => {
    document.title = "Lead ITES — Connecting Technology, Business & Growth";
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/articles/:slug" element={<ArticleDetail />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/reports/:slug" element={<ReportDetail />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/lead-generation" element={<LeadGeneration />} />
            <Route path="/partnerships" element={<Partnerships />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
